import useRedeemPublicBook from './useRedeemPublicBook';

export default useRedeemPublicBook;
